module.exports = __webpack_public_path__ + "static/media/thick-leaves-plant.64d49e17.fbx";